import {
  ApplicationRef,
  ComponentRef,
  Injectable,
  ViewContainerRef,
  inject
} from '@angular/core';
import { AbstractLegendInterface, LegendParams } from '@jeppesen-foreflight/jmkw-types';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class LegendFactoryService {
  private readonly _logger = inject(NGXLogger);
  private readonly _appRef = inject(ApplicationRef);

  private _legendHost: ViewContainerRef | null = null;
  legendComponentRef?: ComponentRef<AbstractLegendInterface>;

  get legendHost(): ViewContainerRef | null {
    return this._legendHost;
  }

  set legendHost(host: ViewContainerRef | null) {
    this._logger.debug(
      'Setting legendHost:',
      host ? 'ViewContainerRef set' : 'null'
    );

    // If host is changing, clean up existing component
    if (this._legendHost !== host) {
      this.destroyLegend();
      this._legendHost = host;
    }
  }

  instantiateLegend(id?: string, legendParams?: LegendParams) {
    if (!this._legendHost || !id || !legendParams) {
      return;
    }

    // Clean up any existing legend first
    this.destroyLegend();

    const { legendComponent, ...paramsWithoutLegendComponent } = legendParams;

    this.legendComponentRef =
      this._legendHost.createComponent<AbstractLegendInterface>(
        legendComponent,
        {
          environmentInjector: this._appRef.injector
        }
      );

    Object.assign(this.legendComponentRef.instance, {
      ...paramsWithoutLegendComponent,
      id
    });

    this.legendComponentRef.changeDetectorRef.detectChanges();

    return this.legendComponentRef;
  }

  destroyLegend() {
    if (this.legendComponentRef) {
      this._logger.debug('Destroying legend component');
      this.legendComponentRef.destroy();
      this.legendComponentRef = undefined;
    }
  }
}
